import httpClientAuthorizer from "adapters/IDPAdapter/HttpClientAuthorizer";
import keycloakIDPAdapter from "../IDPAdapter/KeycloakIDPAdapter";
import IDPAdapter from "../IDPAdapter/IDPAdapter";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export default class HttpPGAdapter {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  get(relativePath, data, onSuccess, onError) {
    this.fetch("get", relativePath, data, onSuccess, onError);
  }

  fetch(method, relativePath, data, onSuccess, onError) {
    const url = `${apiBaseUrl}/${relativePath}`;
    this.httpClient.request({
      method: method,
      url: url,
      data: data,
      onSuccess: onSuccess,
      onError: onError,
    });
  }
  request(method, relativePath, data, onSuccess, onError, ignoreError = false) {
    const url = `${apiBaseUrl}/${relativePath}`;
    const requestHttp = () => {
      this.httpClient.request({
        method: method,
        url: url,
        data: data,
        config: httpClientAuthorizer.authorizeRequestConfig({}),
        onSuccess: onSuccess,
        onError: onError,
        ignoreError,
      });
    };
    if (keycloakIDPAdapter.isLoggedIn()) {
      keycloakIDPAdapter
        .getClient()
        .updateToken(0)
        .then((result) => {
          requestHttp();
        })
        .catch((error) => {
          IDPAdapter.logout(window.location.href);
          return;
        });
      return;
    }
    requestHttp();
  }

  getInitialFilters(shortLocale, onSuccess, onError) {
    const data = { lang: this.getLocale(shortLocale) };
    this.get("directory/filter/values", data, onSuccess, onError);
  }

  getIndividualMembers(data, onSuccess, onError) {
    this.get("directory/members", data, onSuccess, onError);
  }

  getCorporateMembers(data, onSuccess, onError) {
    this.get("directory/members", data, onSuccess, onError);
  }

  getMemberDetails(data, onSuccess, onError) {
    this.get("directory/member/details", data, onSuccess, onError);
  }
  getPendingOGLMember(onSuccess, onError) {
    this.request("GET", "account/customer_data/memberships/ogls", null, onSuccess, onError);
  }
  getPendingOGLMemberSingle(onSuccess, onError) {
    this.request("GET", "account/customer_data/single/ogl/memberships", null, onSuccess, onError);
  }
  getAhvCertificate(paysum_amount, onSuccess, onError) {
    const data = { paysum_amount };
    this.request("GET", "account/corporate/ahv_certificate/mandatory", data, onSuccess, onError);
  }
  addPendingOGLMember(ogl_sia_id, onSuccess, onError) {
    const data = { ogl_sia_id };
    this.request("POST", "account/customer_data/memberships/ogls/add", data, onSuccess, onError, true);
  }
  deletePendingOGLMember(ogl_sia_id, onSuccess, onError) {
    const data = { ogl_sia_id };
    this.request("POST", "account/customer_data/memberships/ogls/delete", data, onSuccess, onError);
  }
  confirmPendingOGLMemberSingle(corporate_member_sia_id, onSuccess, onError) {
    const data = { corporate_member_sia_id };
    this.request("POST", "account/customer_data/memberships/ogl/confirm", data, onSuccess, onError);
  }
  refuseOGLMemberSingle(corporate_member_sia_id, onSuccess, onError) {
    const data = { corporate_member_sia_id };
    this.request("POST", "account/customer_data/memberships/ogl/reject", data, onSuccess, onError);
  }

  getSinglesWorkInfo(shortLocale, onSuccess, onError) {
    const data = { lang: this.getLocale(shortLocale) };
    this.request("GET", "account/customer_data/single/work/information", data, onSuccess, onError);
  }

  getLocale(shortLocale) {
    const locales = {
      de: "de_DE",
      en: "en_US",
      fr: "fr_CH",
      it: "it_IT",
    };
    return locales[shortLocale];
  }

  checkValueAppAuthorization(onSuccess, onError) {
    const keycloak = IDPAdapter.getClient();
    const siaRole = keycloak?.tokenParsed.realm_access?.roles[0] || null;
    const clientRole = keycloak?.idTokenParsed?.resource_access?.["value-app"].roles[0] || null;
    const entryPoint = "value-app/manage";
    const data = {
      sia_role: siaRole,
      client_role: clientRole,
      entry_point: entryPoint,
    };
    this.request("get", "global/authorized", data, onSuccess, onError);
  }

  getValueAppProjectList(onSuccess, onError) {
    const data = {};
    this.request("get", "valueapp/projects", data, onSuccess, onError);
  }

  addValueAppProject(data, onSuccess, onError) {
    this.request("post", "valueapp/projects/add", data, onSuccess, onError);
  }

  // Expects: { project_id: TEXT, data: JSON }
  updateValueAppProject(data, onSuccess, onError) {
    this.request("post", "valueapp/projects/update", data, onSuccess, onError);
  }

  closeValueAppProject(data, onSuccess, onError) {
    this.request("post", "valueapp/projects/close", data, onSuccess, onError);
  }
}
